export default {
  name: {
    name: "课时名称",
    attr: "name",
    value: "",
    isHide: false,
    isReadonly: false,
    sort: 1,
    rules: [
      { required: true, message: "请选择", trigger: "blur" },
    ],
    configs: {
      type: "swim",
      change: "onChangeSwim",
      placeholder: "请选择",
      selData: [{ label: "选项一", value: 1 }],
    },
  },
  title: {
    name: "课时标题",
    attr: "title",
    value: "",
    isHide: false,
    isReadonly: false,
    sort: 1,
    rules: [
      { required: true, message: "请输入", trigger: "blur" },
    ],
    configs: {
      type: "device",
      placeholder: "请输入",
    },
  },
  unit: {
    name: "所属单元",
    attr: "unit",
    value: "",
    isHide: false,
    isReadonly: false,
    sort: 1,
    rules: [
      { required: true, message: "请输入", trigger: "blur" },
    ],
    configs: {
      type: "sensor",
      placeholder: "请输入",
    },
  },
  known: {
    name: "教学知识点",
    attr: "known",
    value: "",
    isHide: false,
    isReadonly: false,
    sort: 1,
    rules: [
      { required: true, message: "请输入", trigger: "blur" },
    ],
    configs: {
      type: "number",
      placeholder: "请输入",
    },
  },
  content: {
    name: "内容介绍",
    attr: "content",
    value: "",
    isHide: false,
    isReadonly: false,
    sort: 1,
    rules: [
      { required: true, message: "请选择", trigger: "blur" },
    ],
    configs: {
      type: "number",
      placeholder: "请选择",
      selData: [{ label: "选项一", value: 1 }],
    },
  },
  createTime: {
    name: "课时创建时间",
    attr: "createTime",
    value: "",
    isHide: false,
    isReadonly: false,
    sort: 1,
    rules: [
      { required: true, message: "请选择", trigger: "blur" },
    ],
    configs: {
      type: "select",
      placeholder: "请选择",
      selData: [{ label: "选项一", value: 1 }],
    },
  },
  complete: {
    name: "课中完成状态",
    attr: "complete",
    value: "",
    isHide: false,
    isReadonly: false,
    sort: 1,
    rules: [
      { required: true, message: "请选择", trigger: "blur" },
    ],
    configs: {
      type: "select",
      placeholder: "请选择",
      selData: [{ label: "选项一", value: 1 }],
    },
  },
  updateTime: {
    name: "课中更新时间",
    attr: "updateTime",
    value: "",
    isHide: false,
    isReadonly: false,
    sort: 1,
    rules: [
      { required: true, message: "请选择", trigger: "blur" },
    ],
    configs: {
      type: "select",
      placeholder: "请选择",
      selData: [{ label: "选项一", value: 1 }],
    },
  },
  updateState: {
    name: "课中更新状态",
    attr: "updateState",
    value: "",
    isHide: false,
    isReadonly: false,
    sort: 1,
    rules: [
      { required: true, message: "请选择", trigger: "blur" },
    ],
    configs: {
      type: "select",
      placeholder: "请选择",
      selData: [{ label: "选项一", value: 1 }],
    },
  },
};
